'use client';

import { useState, useCallback, useEffect } from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';
import { useLocale } from 'next-intl';

import { cleanupGoogleMapsScripts } from '../utils';

const GoogleMapDialogProvider = ({ children }) => {
  const locale = useLocale();
  const [mapKey, setMapKey] = useState(0);

  const remountMap = useCallback(() => {
    cleanupGoogleMapsScripts();
    setMapKey(prev => prev + 1);
  }, [locale]);

  useEffect(() => {
    const prevLanguage = localStorage.getItem('prevLanguage');
    if (prevLanguage && prevLanguage !== locale) {
      localStorage.setItem('prevLanguage', locale);
      remountMap();
    } else if (!prevLanguage) {
      localStorage.setItem('prevLanguage', locale);
    }
  }, [locale, remountMap]);

  return (
    <APIProvider key={mapKey} apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY} language={locale}>
      {children}
    </APIProvider>
  );
};

export default GoogleMapDialogProvider;